import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import { getAlarmList, saveUserLastOperationRecord } from '@blade/common/api/alarm-center';
import lang from '@blade/common/pages/alert-details/lang/index';
import { HandlealAlarmType } from '@blade/common/store/alrm-type';
import TableList from '@blade-sxp/alarm-center/pages/components/alarm-list/table-list.vue';
import alarmCenterDialog from '@blade/common/pages/alarm-center-dialog/index.vue';
import { AlarmDetailsModule } from '@blade/common/store/alarm-details';
import { AlarmCenterModule } from '@blade-sxp/alarm-center/store/index';
import { alarmStackDetails } from '@blade-sxp/alarm-center/api/index';
import moment from 'moment';
const Service = {
    alarmStackDetails,
};
let AlarmList = class AlarmList extends Vue {
    userLastOperationRecord;
    switchValue = true;
    isScroll = true;
    taskList = [];
    dialogVisible = false;
    pagination = {
        page: 0,
        size: 20,
        total: 0,
    };
    dateTime = '';
    isAddList = true;
    alarListTotal = [];
    loading = false;
    allTaskList = [];
    isSelf = 'self'; // 是否是跳转页面
    lengthIsEnough = false; // 首次加载长度是否够
    firstTaskList = []; //
    // updateTimer: number = 0;
    // seconds: number = 30;
    get alerTypeMap() {
        return HandlealAlarmType.alarmTypeMap;
    }
    get portraitId() {
        return this.$route.query.portraitId || null;
    }
    get recordIds() {
        return this.$route.query.recordIds || null;
    }
    get details() {
        return AlarmDetailsModule.detailsData;
    }
    get isTaskType() {
        return AlarmDetailsModule.isTaskType;
    }
    handleDetails() {
        this.dialogVisible = true;
        // clearInterval(this.updateTimer);
    }
    isEmptyObj(obj) {
        return JSON.stringify(obj) === '{}';
    }
    mounted() {
        const routeQuery = this.$route.query;
        const isJump = this.isEmptyObj(routeQuery);
        if (this.portraitId) {
            AlarmCenterModule.updateSearchdata({
                incidentTypes: ['FACE_MATCH'],
            });
        }
        if (isJump || this.portraitId) {
            this.isSelf = 'self';
        }
        else {
            this.isSelf = 'monitor';
        }
        // clearInterval(this.updateTimer);
        // this.updateTimer = window.setInterval(() => {
        //   this.taskList = [];
        //   this.allTaskList = [];
        //   this.firstTaskList = [];
        //   this.alarListTotal = [];
        //   this.getAlarmList('init');
        // }, this.seconds * 1000);
        this.getAlarmList('init');
        this.$nextTick(() => {
            if (document.querySelector('.scroll-box')) {
                const selectWrap = document.querySelector('.scroll-box');
                selectWrap.addEventListener('scroll', this.handleCurrentChange);
            }
        });
    }
    saveUserLastOperationRecordFunc(data) {
        let params = {
            operationRecords: [
                {
                    operationRecord: data,
                    recordKey: 'alarmList',
                },
            ],
        };
        saveUserLastOperationRecord(params)
            .then((res) => { })
            .catch((err) => {
            this.$message({ message: err, type: 'error' });
        });
    }
    handleCurrentChange() {
        let scrollWrap = document.querySelector('.scroll-box');
        let currentScrollTop = scrollWrap.scrollTop;
        let currentOffsetHeight = scrollWrap.scrollHeight;
        let currentClientHeight = scrollWrap.clientHeight;
        if (Math.round(currentScrollTop + currentClientHeight) >= currentOffsetHeight - 50) {
            if (this.allTaskList.length > 25) {
                this.addTaskList();
            }
            else if (this.isScroll && this.isAddList) {
                this.getAlarmList('append');
            }
        }
    }
    addTaskList() {
        // this.taskList = this.taskList.concat(this.allTaskList.splice(0, 25));
        this.taskList = [...this.allTaskList.splice(0, 25)];
    }
    async formSerch() {
        this.firstTaskList = [];
        this.dateTime = '';
        this.alarListTotal = [];
        AlarmDetailsModule.updateAlarListTotal([]);
        this.$refs.tableList.scrollTop = 0;
        await this.getAlarmList();
    }
    isObjectEmpty(obj) {
        return Object.keys(obj).length === 0;
    }
    async getAlarmList(type) {
        this.loading = true;
        this.isScroll = false;
        if (this.isSelf === 'self' && !this.lengthIsEnough) {
            this.taskList = [];
        }
        let incidentTypes = this.isSelf === 'monitor' ? [] : AlarmCenterModule.searchdata?.incidentTypes ?? [];
        let foldedFields = [];
        if (incidentTypes?.length > 0) {
            if (incidentTypes?.[0] === 'FACE_MATCH' || incidentTypes?.[0] === 'INCIDENT_PEDESTRIAN_ATTRIBUTE_MATCHED') {
                foldedFields = ['dataMark.dataMark_portraitId', 'dataMark.dataMark_taskId']; // 人脸按照“任务 + 人像”规则 && 人体按照“任务 + 人体”规则
            }
            else if (incidentTypes?.[0] === 'INCIDENT_AUTOMOBILE_LICENSE_PLATE_MATCHED' ||
                incidentTypes?.[0] === 'INCIDENT_AUTOMOBILE_ATTRIBUTE_MATCHED') {
                foldedFields = ['dataMark.dataMark_vehicleId', 'dataMark.dataMark_taskId']; // 人体按照“任务 + 车辆”规则
            }
            else {
                foldedFields = ['dataMark.dataMark_taskId', 'deviceId']; // 其他事件按照“任务 + 相机”规则
            }
        }
        else {
            foldedFields = [];
        }
        let foldedConfiguration = {
            dateTime: type === 'init' ? '' : this.dateTime,
            folded: true,
            foldedFields: foldedFields,
            foldingTimePeriod: 1,
            foldingTimeUnit: 'DAY',
        };
        let reqParam = {
            ...AlarmCenterModule.searchdata,
            incidentTypes,
            deviceIds: this.isSelf === 'monitor' ? [] : AlarmCenterModule.searchdata.deviceIds,
            dateEnd: this.isSelf === 'monitor' ? '' : AlarmCenterModule.searchdata.dateEnd,
            dateStart: this.isSelf === 'monitor' ? '' : AlarmCenterModule.searchdata.dateStart,
            recordIds: this.recordIds && this.isSelf === 'monitor' ? [this.recordIds] : null,
            portraitId: this.portraitId ? this.portraitId : null,
            foldedConfiguration: this.isSelf === 'self' ? foldedConfiguration : null,
        };
        const res = await getAlarmList({ ...reqParam });
        this.saveUserLastOperationRecordFunc(reqParam);
        // 获取对象的最后一条，如果continuousQuery 为true 就继续请求 nextDateTime 下次请求的时间
        if (res && Object.keys(res).length > 0) {
            const keys = Object.keys(res);
            const lastKey = keys[keys.length - 1];
            const lastValue = res[lastKey];
            const { nextFoldedQueryConfigure } = lastValue || {};
            this.dateTime = this.isSelf === 'self' ? nextFoldedQueryConfigure?.nextDateTime : '';
            this.isAddList = nextFoldedQueryConfigure?.continuousQuery ?? '';
        }
        if (res && !this.isObjectEmpty(res)) {
            const appendList = res;
            if (this.isSelf === 'monitor') {
                // 如果从监控中心调整过来，弹窗显示第一条
                const { list = [] } = appendList || {};
                list.length > 0 && AlarmDetailsModule.updateDetailsData(list[0]);
                this.dialogVisible = true;
                // this.$router.push({ query: {} });
            }
            else {
                this.firstTaskList = this.firstTaskList.concat(appendList);
                this.alarListTotal.push(res.total);
                AlarmDetailsModule.updateAlarListTotal(this.alarListTotal);
                if (this.firstTaskList.length > 3 || !this.isAddList) {
                    this.lengthIsEnough = true;
                    this.isScroll = true;
                    if (type === 'append') {
                        // this.allTaskList = [...this.allTaskList, ...this.firstTaskList];
                        this.allTaskList = [...this.allTaskList, appendList];
                        // this.taskList = this.taskList.concat(this.allTaskList.splice(0, 25));
                        this.taskList = this.taskList.concat(res);
                    }
                    else {
                        this.allTaskList = [...this.firstTaskList];
                        this.taskList = [...this.allTaskList.splice(0, 25)];
                        if (this.portraitId) {
                            this.$router.push({ query: {} });
                            AlarmCenterModule.updateSearchdata({
                                incidentTypes: null,
                            });
                        }
                    }
                    AlarmCenterModule.updateAlertsNum(this.taskList.length);
                    // this.sortTaskList();
                    this.$nextTick(() => {
                        this.loading = false;
                    });
                }
                else {
                    this.getAlarmList();
                }
            }
        }
    }
    // 请求完所有告警数据后排序
    sortTaskList() {
        this.taskList = this.taskList.sort((cur, next) => Number(next.alertTime) - Number(cur.alertTime));
        this.allTaskList = this.allTaskList.sort((cur, next) => Number(next.alertTime) - Number(cur.alertTime));
    }
    async closeDialog() {
        this.dialogVisible = false;
        if (this.isSelf === 'monitor') {
            this.isSelf = 'self';
            this.$router.push({ query: {} });
            this.getAlarmList();
            return;
        }
        await this.getAlarmStackDetails();
        AlarmDetailsModule.clearDetailsData();
    }
    async getAlarmStackDetails() {
        const { alertLevel, foldedConfiguration, keyWord, incidentStatus, incidentTypes, favorite, deviceIds } = AlarmCenterModule.searchdata || {};
        // 拿到点击卡片的 foldedKey，alertTime，id 通过alertTime和id 来确认更新那一条
        const { foldedKey, alertTime = '', id } = AlarmCenterModule.cardData || {};
        const dataTime = alertTime ? moment(Number(alertTime)).format('YYYY-MM-DD 00:00:00') : '';
        const folded = {
            ...foldedConfiguration,
            dateTime: dataTime || '',
        };
        // (folded as any).dateTime = dataTime || '';
        const types = AlarmDetailsModule?.detailsData?.incidentType;
        const { dateStart = '', dateEnd = '' } = AlarmDetailsModule.paramTaskIds || {};
        const incident = this.isTaskType.includes(types) ? [types] : [];
        const typeLen = incidentTypes && incidentTypes.length > 0;
        const param = {
            foldedKey: foldedKey,
            dateEnd: dateEnd,
            dateStart: dateStart,
            alertLevel,
            keyWord,
            incidentStatus,
            incidentTypes: typeLen ? incidentTypes : incident,
            favorite,
            deviceIds,
            foldedConfiguration: folded,
            isToTalCount: !!typeLen,
        };
        await Service.alarmStackDetails(param).then((res) => {
            const currentTimestamp = new Date(dataTime).getTime();
            let result = {};
            let itemIndex = 0;
            this.taskList.forEach((item, index) => {
                if (Object.keys(item)?.includes(String(currentTimestamp))) {
                    itemIndex = index;
                    result = item[currentTimestamp];
                }
            });
            if (result && Object.keys(result).length > 0) {
                (this.taskList[itemIndex]?.[currentTimestamp]).total = Number(res.view.foldsTotalByTime || 0);
                const { list = [] } = result || {};
                const findDataIndex = list?.findIndex((item) => item.id === id);
                const newData = { ...AlarmCenterModule.cardData, ...res?.view };
                // 如果 foldsTotal 表明当前卡片已经被删除完了 , 如果大于0 就更新
                const { foldsTotal = 0 } = res.view || {};
                if (foldsTotal === 0) {
                    this.taskList[itemIndex]?.[currentTimestamp]?.list.splice(findDataIndex, 1);
                }
                else {
                    this.taskList[itemIndex]?.[currentTimestamp]?.list.splice(findDataIndex, 1, newData);
                }
            }
        });
    }
    beforeDestroy() {
        // clearInterval(this.updateTimer);
    }
};
__decorate([
    Prop()
], AlarmList.prototype, "userLastOperationRecord", void 0);
AlarmList = __decorate([
    Component({
        name: 'AlarmList',
        components: {
            TableList,
            alarmCenterDialog,
        },
        i18n: {
            messages: lang,
        },
    })
], AlarmList);
export default AlarmList;
